import src from "IMAGE";
export default { src, width: 324, height: 285, blurWidth: 0, blurHeight: 0};
